import React from 'react';
import { Typography } from 'fronton-react';
import cn from 'clsx';
import { IconComponent } from '@fronton/icons-react';
import { createElementKey } from 'utils';
import {
  reviewsBenefitsIcon,
  reviewsBenefitsItem,
  reviewsBenefitsItemNewVariant,
  reviewsBenefitsList,
  reviewsBenefitsText,
} from './reviews-benefits-styles';

export type ReviewBenefitStructure = {
  renderIcon?: (className: string) => React.ReactNode;
  icon?: IconComponent;
  text: string | React.ReactNode;
};

type ReviewsBenefitsProps = {
  benefitsList: ReviewBenefitStructure[];
  className?: string;
  newVariant?: boolean;
}

export const ReviewsBenefits: React.FC<ReviewsBenefitsProps> = ({ benefitsList, className, newVariant = false }) => (
  <ul className={cn(className, reviewsBenefitsList)}>
    {benefitsList.map((benefit, index) => (
      <li
        key={createElementKey('benefit', index)}
        className={cn(reviewsBenefitsItem, { [reviewsBenefitsItemNewVariant]: newVariant })}
      >
        {benefit.icon && (
          <benefit.icon
            className={reviewsBenefitsIcon}
            size="38px"
            color="var(--control-accent)"
            strokeWidth={0.8}
          />
        )}

        {benefit.renderIcon && benefit.renderIcon(reviewsBenefitsIcon)}

        <Typography
          className={reviewsBenefitsText}
          variant="m"
          size="body_long"
          color="text-invert">
          {benefit.text}
        </Typography>
      </li>
    ))}
  </ul>
);
